export const enum TransitionDirection {
  Right = -1,
  None = 0,
  Left = 1,
}
